var _path, _rect, _path2, _circle, _circle2, _path3, _path4, _path5, _rect2, _circle3, _circle4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCanceled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 33,
    viewBox: "0 0 40 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0218 18.5474C9.40973 18.5474 7.94085 19.1606 6.83568 20.1664C6.72438 18.9707 6.70993 17.6904 6.71003 16.6162V16.0079H17.8279V18.8927C17.8279 20.3685 19.0242 21.5649 20.5 21.5649C23.5487 21.5649 25.9798 19.0186 25.8386 15.9731L25.5385 9.49984C25.5385 7.69571 26.9902 7.22966 28.2804 9.01325C29.5534 10.7729 31.169 15.1132 32.3821 18.6156C29.4201 19.057 27.14 21.5861 27.0865 24.6581C24.1656 24.7317 20.5515 24.7659 17.2427 24.7021C17.207 21.2968 14.4355 18.5474 11.0218 18.5474Z",
    fill: "#FF5630"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.25372,
    y: 2.33105,
    width: 14.3399,
    height: 10.4778,
    rx: 1,
    fill: "#FF5630"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1925 8.14217C31.1925 10.0739 31.4295 11.8231 29.7427 11.8231C28.4568 11.8231 24.8436 9.41951 24.8436 7.48783C24.8436 5.55615 26.4022 5.37793 28.089 5.37793C29.7758 5.37793 31.1925 6.21049 31.1925 8.14217Z",
    fill: "#FAA2A2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.0196,
    cy: 24.779,
    r: 5.33662,
    fill: "url(#paint0_linear_892_10859)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.4127,
    cy: 24.7438,
    r: 5.33662,
    fill: "url(#paint1_linear_892_10859)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3448 15.5671C1.84456 14.5764 2.56459 13.4062 3.67444 13.4062H17.301C18.6909 13.4062 19.3234 15.1413 18.2597 16.0358V16.0358C17.9912 16.2615 17.6518 16.3853 17.301 16.3853H10.426H3.67444C3.11236 16.3853 2.59814 16.0689 2.3448 15.5671V15.5671Z",
    fill: "#FAA2A2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7561 6.78125L25.3718 7.18029",
    stroke: "#FF5630",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.2654 5.06833C9.27329 5.03546 9.27742 5.00152 9.27742 4.96682C9.27742 4.67071 8.97692 4.43066 8.60623 4.43066C8.23555 4.43066 7.93505 4.67071 7.93505 4.96682C7.93505 4.98692 7.93643 5.00675 7.93913 5.02628C5.26636 5.48225 4.43039 7.89189 4.53127 9.37851H12.3332C12.5092 7.99843 11.8043 5.64615 9.2654 5.06833Z",
    fill: "url(#paint2_linear_892_10859)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.04699,
    y: 8.71191,
    width: 8.75982,
    height: 1.21062,
    rx: 0.605309,
    fill: "url(#paint3_linear_892_10859)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.0547,
    cy: 24.7981,
    r: 2.20534,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.4089,
    cy: 24.7981,
    r: 2.20534,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_892_10859",
    x1: 11.0196,
    y1: 19.4424,
    x2: 11.0196,
    y2: 30.1156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#454242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818281"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_892_10859",
    x1: 33.4127,
    y1: 19.4072,
    x2: 33.4127,
    y2: 30.0805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#454242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818281"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_892_10859",
    x1: 8.45479,
    y1: 4.50773,
    x2: 8.45479,
    y2: 8.85459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_892_10859",
    x1: 8.4269,
    y1: 8.71191,
    x2: 8.4269,
    y2: 9.92253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCanceled);
export default __webpack_public_path__ + "static/media/ic_canceled.e4e5ae5334e94f7ae83cf6fc55aaa59e.svg";
export { ForwardRef as ReactComponent };